/* eslint-disable import/prefer-default-export */

import hamsClient from 'modules/hams';
import { StoredPromotion } from './model';

export const getPromotion = async (promoCode: string): Promise<StoredPromotion | null> => {
  const r = await hamsClient.get(`/1.0/public/promotion/code/${promoCode}`);
  return r.data;
};
